import { useMemo } from "react";

const ProgressBar = ({ percentage, style, color, children, showContent }) => {
	const percent = useMemo(() => {
		if (!percentage) return 0;
		return Math.max(0, Math.min(100, percentage));
	}, [percentage]);

	return (
		<div style={{ ...style, position: "relative" }}>
			<div
				className="progress-bar-container"
				style={{
					background: color ? color : undefined,
					position: "absolute",
					top: 0,
					left: 0,
				}}
			/>
			<div
				className="progress-bar"
				style={{
					background: color ? color : undefined,
					width: `${percent && percent >= 9 ? percent : 0}%`,
					position: "absolute",
					top: 0,
					left: 0,
				}}
			/>
			{showContent && (
				<div
					style={{
						position: "absolute",
						top: 0,
						left: "45%",
						fontSize: "1.125rem",
						color: "white",
						fontWeight: "700",
					}}
				>
					{children ? children : `${parseFloat(percent).toFixed(0)}%`}
				</div>
			)}
		</div>
	);
};


export default ProgressBar

